// extracted by mini-css-extract-plugin
export default {"container":"addon_container__36wio"};